import { createTransform } from 'redux-persist';

const SetTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState: any, key) => {
    // convert mySet to an Array.
    return { ...inboundState, error: "" };
  },
  // transform state being rehydrated
  (outboundState, key) => {
    // convert mySet back to a Set.
    return { ...outboundState, error: "" };
  },
  // define which reducers this transform gets called for.
  { whitelist: ['auth'] }
);

export default SetTransform;